import React, { useState, useEffect } from 'react';
import {
  Grid,
  Column,
  DataTable,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCell,
  TableToolbar,
  TableToolbarContent,
  TableToolbarSearch,
  Pagination,
  Select,
  Button,
  SelectItem,
  Theme,
} from '@carbon/react';
import { getCountriesList, getAccountingInformationForView } from '../../services/services';
import CommodityHeader from '../../components/Header';
import { useNavigate } from "react-router-dom";

const headers = [
  {
    key: 'ctrycode',
    header: 'Country',
  },
  {
    key: 'compcode',
    header: 'Company',
  },
  {
    key: 'projecod',
    header: 'Code',
  },
  {
    key: 'division',
    header: 'Division',
  },
  {
    key: 'minor',
    header: 'Minor',
  },
  {
    key: 'depanumb',
    header: 'Department Number',
  }
];

const ViewProjects = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [countryList, setCountryList] = useState([]);
  const [countryChosen, setCountryChosen] = useState();
  const [rows, setRows] = useState([]);

  const getCountries = async () => await getCountriesList()
    .then(response => {
      if(response.status === 200){
        response.json()
          .then(response => {
            response.sort((a, b) => a.countryName.localeCompare(b.countryName));
            setCountryList(response);
          })
      }    
    });

  const goHomeScreen = () => {
    navigate('/home')
  };

  const changePaginationState = (pageInfo) => {
    if (page !== pageInfo.page) {
      setPage(pageInfo.page)
    }
    if (pageSize !== pageInfo.pageSize) {
      setPageSize(pageInfo.pageSize)
    }
  }

  const handleTypeSelect = (e, row) => {
    setRows([]);
    /* const type = e.target.id; */
    setCountryChosen(e.target.value);
    let request = {};
    request.ctrycode = e.target.value;
    request.action = 'projects';
    getProjectList(request);
  };

  const getProjectList = async (request) => await getAccountingInformationForView(request)
  .then(response => {
    if(response.status === 200){
      response.json()
        .then(response => {
          parseResponse(response);
        })
    }    
  });  

  function parseResponse(response) {
    const resParsed = response.map((res, i) => {
      const parsed = {};
      parsed["id"] = i.toString();
      parsed["ctrycode"] = res.key.ctrycode;
      parsed["compcode"] = res.key.compcode;
      parsed["projecod"] = res.key.projecod.trim();
      parsed["division"] = res.division;
      parsed["minor"] = res.minor;
      parsed["depanumb"] = res.depanumb;
      return parsed;
    });
    setRows(resParsed);

  };

  useEffect(() => {
    getCountries();
  }, []);

  return (
    <>
      <h2 className="table-title">Projects's List</h2>

      <Grid>
        <Theme theme="g90">
          <CommodityHeader />
        </Theme>
        <Column lg={16} >
        <Button className='style-bttbackID' size="lg" style={{marginBottom: '20px'}} onClick={goHomeScreen}>Back to Home</Button>          
          <DataTable
            isSortable={true}
            rows={rows}
            headers={headers}
            render={({
              rows,
              headers,
              getHeaderProps,
              getRowProps,
              getTableProps,
              onInputChange
            }) => (

              <TableContainer>
                <Select className="style-select"
                  labelText=""
                  defaultValue={countryChosen}
                  value={countryChosen}
                  id="countryDept"
                  onChange={(e) => handleTypeSelect(e)}
                >
                  <SelectItem
                    label="Select country"
                  />
                  {countryList.map((country) => (
                    <SelectItem value={country.countryCode} text={country.countryName} />
                  ))}

                </Select>
                <TableToolbar>
                  <TableToolbarContent>
                    <TableToolbarSearch persistent size="sm" onChange={onInputChange} />
                    {/* pass in `onInputChange` change here to make filtering work */}

                  </TableToolbarContent>
                </TableToolbar>
                <Table {...getTableProps()} useZebraStyles>
                  <TableHead>
                    <TableRow>

                      {headers.map(header => (
                        <TableHeader {...getHeaderProps({ header })}>
                          {header.header}
                        </TableHeader>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.slice((page - 1) * pageSize).slice(0, pageSize).map((row, i) => (
                      <TableRow {...getRowProps({ row })}>
                        {row.cells.map(cell => (
                          <TableCell key={cell.id}>{cell.value}</TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                <Pagination
                  onChange={changePaginationState}

                  backwardText="Previous page"
                  forwardText="Next page"
                  itemsPerPageText="Items per page:"
                  page={page}
                  pageNumberText="Page Number"
                  pageSize={pageSize}
                  pageSizes={[
                    10,
                    25,
                    50,
                    100,
                  ]}
                  totalItems={rows.length}
                />
              </TableContainer>
            )}
          />
        </Column>
      </Grid>
    </>
  );
};

export default ViewProjects;